<template>
	<div class="design-container">
		<div class="design">

			<div class="left" :class="{no3d:!category.is_enable3d}">
				<div class="tabs">
					<div
							class="tab"
							:class="{'active': cur === item.key }"
							v-for="(item,index) in tabs"
							:key="'tab-'+item.key"
							@click="changeNav(item.key)"
							v-if="!!(item.key!=='Style' || (category.is_enable_embroider && fabric_list.color.tech > 0))"
					>
						<div>
							<img :src="cur === item.key ? item.activeImg : item.img" />
							<div>{{item.title}}</div>
						</div>
					</div>
				</div>

				<div class="style-box" v-show="cur === 'Part'">
					<Part :key="'panel-part-'+category.id" />
				</div>
				<div class="style-box" v-show="cur === 'Deep'">
					<Deep :key="'panel-deep-'+category.id" />
				</div>
				<div class="style-box" v-show="cur === 'Fabric'">
					<Fabric :key="'panel-fabric-'+category.id" />
				</div>
				<div class="style-box" v-show="cur === 'Style'" v-if="category.is_enable_embroider && fabric_list.color.tech > 0">
					<Style :key="'panel-style-'+category.id" />
				</div>

			</div>
			<div class="center">
				<GlbRenderer3D :key="'renderer-'+category.id" :model3d-list="model3d_list" :main-fabric-image="fabric_list" v-if="category.ext3d == 'glb' && category.is_enable3d"></GlbRenderer3D>
			</div>

			<div class="right" :class="{no3d:!category.is_enable3d}">
				<Confirm></Confirm>
			</div>

			<div class="right2" v-if="!category.is_enable3d" :class="{no3d:!category.is_enable3d}">
				<Summary ></Summary>
			</div>
		</div>
	</div>

</template>

<script>
	import {mapState} from 'vuex'
	import Fabric from "./components/Fabric";
	import Part from "./components/Part";
	import Deep from "./components/Deep";
	import Style from "./components/Style";
	import GlbRenderer3D from "./components/GlbRenderer3D.vue";
	import Confirm from "./components/Confirm";
	import Summary from "./components/Summary";
	export default {
		name: "Design",
		components: {
			Part,
			Deep,
			Fabric,
			Style,
			GlbRenderer3D,
			Confirm,
			Summary
		},
		data() {
			return {
				cur: '',
				is_show_fabric_modal: false
			};
		},
		computed: {
			...mapState({
				category: (state) => state.mtm.picked_category,
				model3d_list: (state) => state.mtm.form_data.model3d_list,
				fabric_list: (state) => state.mtm.form_data.fabric_list,
				form_data: (state) => state.mtm.form_data,
			}),
			tabs() {
				if (this.form_data.mtm_type == 2) {
					return [{
						title: "面料",
						key: 'Fabric',
						img: require("../../assets/images/design/fabric.png"),
						activeImg: require("../../assets/images/design/fabric-active.png"),
					},
						{
							title: "个性",
							key: 'Style',
							img: require("../../assets/images/design/personality.png"),
							activeImg: require("../../assets/images/design/personality-active.png"),
						},
					]
				} else {
					return [
						{
							title: "款式设计",
							key: 'Part',
							img: require("../../assets/images/design/design.png"),
							activeImg: require("../../assets/images/design/design-active.png"),
						},
						{
							title: "深度设计",
							key: 'Deep',
							img: require("../../assets/images/design/design.png"),
							activeImg: require("../../assets/images/design/design-active.png"),
						},
						{
							title: "面料",
							key: 'Fabric',
							img: require("../../assets/images/design/fabric.png"),
							activeImg: require("../../assets/images/design/fabric-active.png"),
						},
						{
							title: "个性",
							key: 'Style',
							img: require("../../assets/images/design/personality.png"),
							activeImg: require("../../assets/images/design/personality-active.png"),
						},
					]
				}

			}
		},
		created() {
			// 缓存款式数据
			localStorage.setItem('category', JSON.stringify(this.category))
		},
		mounted() {
			if (this.form_data.mtm_type == 2) {
				this.cur = 'Fabric'
			} else {
				this.cur = 'Part'
			}

			this.$emit("showLogin", false);
			this.$emit("showBack", true);
			this.$emit("showNav", false);
			this.$emit("showFooter", false);
		},
		methods: {
			changeNav(cur) {
				this.cur = cur;
			},
		},
		beforeRouteLeave(to, from, next) {
			// 导航离开该组件的对应路由时调用
			// 可以访问组件实例 `this`
			this.$Spin.hide();
			next()
		}
	};
</script>

<style lang="scss" scoped>
	// chrome,safari浏览器滚动条适配
	::-webkit-scrollbar {
		width: 3px;
		height: 3px;
	}
	::-webkit-scrollbar-track {
		background: #f3f4f9;
		border-radius: 2px;
	}
	::-webkit-scrollbar-thumb {
		background: #c8d2e0;
		border-radius:10px;
	}
	::-webkit-scrollbar-thumb:hover{
		background: #333
	}
	::-webkit-scrollbar-corner {
		background: #c8d2e0
	}

	.design-container {
		scrollbar-color: #c8d2e0 #f3f4f9;
		// 滚动条宽度有三种：thin、auto、none
		scrollbar-width: thin;
		position: absolute;
		top: 80px;
		left: 0;
		right: 0;
		bottom: 0;
		.design {
			width: 100%;
			height: 100%;
			background: #f3f4f5;
			position: relative;
			display: flex;
			justify-content: center;
			align-items: center;
			.left {
				position: absolute;
				top: 0;
				left: 0;
				width: 440px;
				height: 100%;
				overflow-y: hidden;
				background: #ffffff;
				box-shadow: 2px 2px 23px rgba(0, 0, 0, 0.06);
				display: flex;
				.tabs {
					width: 80px;
					background: #0f114a;
					.tab {
						height: 70px;
						font-size: 14px;
						font-weight: 400;
						color: #edd4ac;
						margin-bottom: 20px;
						text-align: center;
						cursor: pointer;
						img {
							width: 20px;
							height: 20px;
							margin-top: 13px;
						}
					}
					.active {
						background: #ffffff;
						font-weight: bold;
						color: #0f114a;
					}
				}
				.style-box {
					width: 375px;
					padding-left:20px;
					.section-wrap {
						width: 100%;
						height: 100%;
						overflow-y: scroll;
					}
				}
			}


			.left.no3d {
				width: 1105px;
				.style-box {
					width: 1040px;
				}
			}

			.ivu-icon {
				line-height: 1.7;
			}


			.ivu-icon {
				line-height: 1.7;
			}

			.center {
				width: 800px;
				height: 800px;
			}

			.tools-panel {
				position: absolute;
				top: 20px;
				right: 320px;
				width: 60px;
				.btn-wrap{
					display: flex;
					flex-wrap: wrap;
					justify-content: center;
					width: 60px;
					margin-bottom: 20px;
					cursor: pointer;
					.btn-tools {
						width: 48px;
						height: 48px;
					}
					.text {
						margin-top: 5px;
						color: #333333;
						font-size: 13px;
					}
				}

			}

			.right {
				width: 270px;
				height: 100%;
				overflow-y: scroll;
				background: #ffffff;
				box-shadow: 0 2px 23px rgba(0, 0, 0, 0.06);
				position: absolute;
				top: 10px;
				right: 20px;
				&.no3d {
					width: 385px;
					right: 400px;
				}
			}

			.right2.no3d {
				width: 340px;
				background: #ffffff;
				box-shadow: 0 2px 23px rgba(0, 0, 0, 0.06);
				position: absolute;
				top: 10px;
				right: 30px;
			}

		}
	}
</style>
